module.exports = __webpack_public_path__ + "static/media/Star.f965963f.png";